import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/__auth/admin/reports")({
  component: ReportsLayout,
});

function ReportsLayout() {
  return <Outlet />;
}

export const MONTHS = [
  { value: 1, key: "january" },
  { value: 2, key: "february" },
  { value: 3, key: "march" },
  { value: 4, key: "april" },
  { value: 5, key: "may" },
  { value: 6, key: "june" },
  { value: 7, key: "july" },
  { value: 8, key: "august" },
  { value: 9, key: "september" },
  { value: 10, key: "october" },
  { value: 11, key: "november" },
  { value: 12, key: "december" },
];

export function parseCsv(csvContent: string) {
  if (!csvContent) return null;
  const lines = csvContent.split("\n").map(line => line.trim());
  const dataLines = lines.slice(5).filter(Boolean);
  if (dataLines.length <= 1) return null;

  const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
  const headers = dataLines[0].split(regex).map(h => h.trim().replace(/^["']|["']$/g, ""));

  const rows = dataLines.slice(1).map(line => {
    const values = line.split(regex).map(v => v.trim().replace(/^["']|["']$/g, ""));
    const row: Record<string, string> = {};
    headers.forEach((header, index) => {
      row[header] = values[index] || "";
    });
    return row;
  });

  return { headers, rows };
}

export function formatBytes(bytes: number) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

export function formatDateTime(dateStr?: string, locale: string = "pt-BR") {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    return date.toLocaleString(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch (e) {
    return dateStr;
  }
}

export const downloadCsvFile = (filename: string, csvContent: string) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
